// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"328f3bd6","297":"4da75565","643":"af59bb04","787":"0c13ba6c","959":"2789199f"}[chunkId] + ".chunk.js";
};